"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NutritionUtils {
    constructor() {
        this.getAverageFactsForDayRange = (days, calorieBudget) => {
            const { trainingDays, nonTrainingDays } = this.sortDaysByType(days);
            const trainingDaysTotal = this.getTotalFactsValues(trainingDays);
            const nonTrainingDaysTotal = this.getTotalFactsValues(nonTrainingDays);
            const averageTrainingDays = this.getAverageFromNutritionDays(trainingDaysTotal, trainingDays);
            const averageNonTrainingDays = this.getAverageFromNutritionDays(nonTrainingDaysTotal, nonTrainingDays);
            return {
                trainingDays: this.createFactsMapFromFacts(averageTrainingDays, calorieBudget.forTrainingDay),
                nonTrainingDays: this.createFactsMapFromFacts(averageNonTrainingDays, calorieBudget.forNonTrainingDay),
            };
        };
        this.sortDaysByType = (days) => {
            const trainingDays = [];
            const nonTrainingDays = [];
            days.forEach((day) => {
                if (day.method === "handpalm")
                    return;
                if (day.dayType === "TRAINING") {
                    return trainingDays.push(day);
                }
                nonTrainingDays.push(day);
                return;
            });
            return {
                trainingDays,
                nonTrainingDays,
            };
        };
        this.getTotalFactsValues = (days) => {
            return days.reduce((acc, day) => {
                var _a, _b, _c, _d, _e;
                return ({
                    calories: acc.calories + ((_a = day.nutritionFacts) === null || _a === void 0 ? void 0 : _a.calories),
                    protein: acc.protein + ((_b = day.nutritionFacts) === null || _b === void 0 ? void 0 : _b.protein),
                    carbs: acc.carbs + ((_c = day.nutritionFacts) === null || _c === void 0 ? void 0 : _c.carbs),
                    fats: acc.fats + ((_d = day.nutritionFacts) === null || _d === void 0 ? void 0 : _d.fats),
                    fibers: acc.fibers + ((_e = day.nutritionFacts) === null || _e === void 0 ? void 0 : _e.fibers),
                });
            }, {
                fats: 0,
                fibers: 0,
                protein: 0,
                carbs: 0,
                calories: 0,
            });
        };
        this.getAverageFromNutritionDays = (totalFacts, days) => {
            if (!days || !days.length) {
                return {
                    calories: 0,
                    protein: 0,
                    carbs: 0,
                    fats: 0,
                    fibers: 0,
                };
            }
            return {
                calories: this.getAverageFromFact(totalFacts, days, "calories"),
                protein: this.getAverageFromFact(totalFacts, days, "protein"),
                carbs: this.getAverageFromFact(totalFacts, days, "carbs"),
                fats: this.getAverageFromFact(totalFacts, days, "fats"),
                fibers: this.getAverageFromFact(totalFacts, days, "fibers"),
            };
        };
        this.getAverageFromFact = (facts, days, key) => facts[key] / days.filter(this.hasValue(key)).length || 0;
        this.hasValue = (key) => (day) => {
            var _a;
            return !!((_a = day.nutritionFacts) === null || _a === void 0 ? void 0 : _a[key]);
        };
        this.calcProgress = (planned, current) => {
            return Math.round((current * 100) / planned);
        };
        this.resolveFactStatus = (percent, isOverScale) => {
            if (!isOverScale) {
                if (percent >= 100)
                    return "OK";
            }
            if (percent >= 95 && percent <= 105)
                return "OK";
            if ((percent > 85 && percent < 95) || (percent > 105 && percent <= 115))
                return "WARN";
            return "ALERT";
        };
        this.getFactStatusFromProgress = (planned, actual, isOverScale = true) => {
            return this.resolveFactStatus(this.calcProgress(planned, actual), isOverScale);
        };
        this.createFactsMapFromFacts = (facts, calorieBudget) => {
            const map = new Map();
            map.set("calories", {
                difference: Math.round(facts.calories),
                status: this.getFactStatusFromProgress(calorieBudget.calories, facts.calories),
            });
            map.set("carbs", {
                difference: Math.round(facts.carbs),
                status: this.getFactStatusFromProgress(calorieBudget.carbohydrates, facts.carbs),
            });
            map.set("protein", {
                difference: Math.round(facts.protein),
                status: this.getFactStatusFromProgress(calorieBudget.proteins, facts.protein),
            });
            map.set("fats", {
                difference: Math.round(facts.fats),
                status: this.getFactStatusFromProgress(calorieBudget.fats, facts.fats),
            });
            map.set("fibers", {
                difference: Math.round(facts.fibers),
                status: this.getFactStatusFromProgress(calorieBudget.fibers, facts.fibers, false),
            });
            return map;
        };
    }
}
exports.default = NutritionUtils;
//# sourceMappingURL=NutritionUtils.js.map